import { useIdentity } from '@vp/ubik-context'
import { useDispatch } from 'react-redux'
import { setAuthData } from '~/app/store/auth/actions'
import { useEffect } from 'react'

export const useUpdateAuthData = (): void => {
  const dispatch = useDispatch()
  const { auth, identity } = useIdentity()
  useEffect(() => {
    dispatch(setAuthData({ canonicalId: auth?.getCanonicalId(), authorizationHeader: identity?.authorizationHeader }))
  }, [auth, dispatch, identity, setAuthData])
}
